import { render } from "./ModalAlertaOK.vue?vue&type=template&id=225a4862&ts=true"
import script from "./ModalAlertaOK.vue?vue&type=script&lang=ts"
export * from "./ModalAlertaOK.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__